import TEXT from './generated/TEXT/formatDuration';

TEXT.DEFINE({
  /** Placeholder when remaining time is being calculated */
  infiniteRemainingTime: 'Calculating time left...',
  /** Suffix for time remaining (e.g. "5m left") */
  left: ' left',
  /** Short duration in days (e.g. "2d") */
  days: (value: number) => `${value}d`,
  /** Short duration in hours (e.g. "2h") */
  hours: (value: number) => `${value}h`,
  /** Short duration in minutes (e.g. "3m") */
  minutes: (value: number) => `${value}m`,
  /** Short duration in seconds (e.g. "48s") */
  seconds: (value: number) => `${value}s`,
});

/**
 * Formats number of seconds into minutes/days/hours, like "1 minute",
 * "2 hours", or "3 days".
 * @param {number} duration - Number of seconds.
 * @returns {string} - Formatted string of the duration.
 */
export function formatDuration(
  duration: number,
  includeSuffix = false
): string {
  if (duration === Infinity) return TEXT.infiniteRemainingTime;

  const minInSecs = 60;
  const hourInSecs = minInSecs * 60;
  const dayInSecs = hourInSecs * 24;

  let unit = 's' as 'd' | 'h' | 'm' | 's';
  let divisor = 1;
  if (duration >= dayInSecs) {
    unit = 'd';
    divisor = dayInSecs;
  } else if (duration >= hourInSecs) {
    unit = 'h';
    divisor = hourInSecs;
  } else if (duration >= minInSecs) {
    unit = 'm';
    divisor = minInSecs;
  }
  const value = Math.round(duration / divisor);
  const formatUnit = {
    d: TEXT.days,
    h: TEXT.hours,
    m: TEXT.minutes,
    s: TEXT.seconds,
  };

  return `${formatUnit[unit](value)}${includeSuffix ? TEXT.left : ''}`;
}
